export const WORKATO_EMBEDDING_CLIENT_SCRIPT = Object.freeze({
    EU: 'https://embedding.workato.com/r/embedding-client-eu.js',
    US: 'https://embedding.workato.com/r/embedding-client.js'
});

export const WORKATO_BASE_URLS = Object.freeze({
    EU: 'https://app.eu.workato.com',
    US: 'https://www.workato.com'
});
export const WORKATO_REGIONS = Object.freeze({
    EU: 'EU',
    eu: 'EU',
    US: 'US',
    us: 'US'
});

export enum RECIPE_ACTIONS {
    LICENSE = 'license',
    OFFBOARD = 'offboard',
    ONBOARD = 'onboard'
}
